<template>
  <div class="funcionarios-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center">
        <button class="btn-back" @click="$router.push('/')">
          <i class="fas fa-arrow-left"></i>
        </button>
        <h1 class="page-title ml-3">Gestão do Time</h1>
      </div>
      <button v-if="canManageEmployees" class="btn-orange" @click="showModal">
        <i class="fas fa-user-plus mr-2"></i>Adicionar pessoa
      </button>
    </div>

    <b-spinner v-if="loading" />
    <template v-else>
      <div class="person-search">
        <label for="nameSearch" class="search-label">Buscar por nome:</label>
        <input type="text" id="nameSearch" v-model="nameSearch" class="search-input" placeholder="Digite um nome">
      </div>
      <div class="team-container">
        <ul class="team-list-wrapper">
          <li v-for="person in filteredItems" :key="person.id" class="person-card">
            <section>
              <h2 class="person-name">{{ person.name }}</h2>
              <div class="person-info">
                <h3 v-if="isSuperAdmin" class="person-company">{{ person.company }}</h3>
                <h3 :class="getRoleClass(person.role)" class="person-role">{{ person.role }}</h3>
              </div>
              <div class="person-actions">
                <div class="action-row">
                  <button class="btn-orange-action btn-small" @click="goToEmployeeAnalyses(person.name)" title="Ver análises feitas por essa pessoa">
                    <i class="fas fa-chart-line"></i>
                    <span>Análises</span>
                  </button>
                  <button class="btn-orange-action btn-small" @click="showFuncionariosModal(person.id)" title="Ver equipamentos autorizados a essa pessoa">
                    <i class="fas fa-tools"></i>
                    <span>Equipamentos</span>
                  </button>
                </div>
                <button v-if="canManageEmployees" class="btn-delete-action btn-small" @click="confirmDeleteEmployee(person.id)" title="Remover funcionário">
                  <i class="fas fa-trash"></i>
                  <span>Remover</span>
                </button>
              </div>
              <span v-if="canManageEmployees" class="person-edit" title="Editar dados da pessoa" @click="showEditModal(person.id)"><b-icon icon="pencil-square"></b-icon></span>
            </section>
          </li>
        </ul>
      </div>
      <p v-if="error" class="error">{{ error }}</p>
    </template>

    <!-- Modal de Cadastro -->
    <Modal name="cadastroFuncionario" title="Novo Funcionário" :onlyBody="true" @close="handleNewEmployeeModalClose">
      <template v-slot:default>
        <div class="wrapper">
          <b-form @submit.prevent="onSubmit">
            <b-row>
              <b-col md="6">
                <b-form-group label="Nome">
                  <b-form-input v-model="form.name" type="text" required placeholder="Digite o nome" />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Email">
                  <b-form-input v-model="form.email" type="email" required placeholder="Digite o email"
                    pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$" />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Documento">
                  <b-form-input v-model="form.idDocument" type="text" required placeholder="CPF ou CNPJ"
                    @input="formatarDocumento" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Cargo">
                  <b-form-select v-model="form.role" :options="roles" required />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Senha">
                  <b-form-input v-model="form.password" type="password" required placeholder="Digite sua senha" :disabled="editMode" />
                  <b-form-invalid-feedback v-if="senhaCurta" class="d-block text-danger">
                    A senha deve ter no mínimo 6 caracteres.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Confirme sua senha">
                  <b-form-input v-model="form.confirmPassword" type="password" required
                    placeholder="Confirme sua senha" :disabled="editMode" />
                  <b-form-invalid-feedback v-if="senhasNaoBatem" class="d-block text-danger">
                    As senhas não coincidem.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Empresa">
                  <b-form-select v-model="form.companyId" :options="companies" required :disabled="isManager" />
                </b-form-group>
              </b-col>
            </b-row>

            <button type="submit" class="btn-orange" :disabled="!formValido">
              <i class="fas fa-save mr-2"></i>Salvar
            </button>
            <button type="button" class="btn-cancel ml-2" @click="$bvModal.hide('cadastroFuncionario-modal')">
              <i class="fas fa-times mr-2"></i>Cancelar
            </button>
          </b-form>
        </div>
      </template>
    </Modal>

    <!-- Modal Funcionários -->
    <EmployeeEquipmentModal :employeeId="selectedEmployeeId" />
  </div>
</template>

<script>
/* eslint-disable */
import { request,api } from '@/services';
import Modal from '../../static/Modal.vue';
import { DB_ROLES, DB_ROUTES } from '../../../constants';
import EmployeeEquipmentModal from '../../modals/EmployeeEquipmentModal.vue';
import { BIcon, BIconPencilSquare } from 'bootstrap-vue'

export default {
  components: {
    Modal,
    EmployeeEquipmentModal,
    BIcon,
    BIconPencilSquare
  },
  data() {
    return {
      items: [],
      loading: true,
      error: null,
      form: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        idDocument: '',
        companyId: null,
        role: null
      },
      roles: [],
      companies: [],
      selectedEmployeeId: null,
      fields: [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'company', label: 'Empresa', sortable: true },
        { key: 'actions', label: 'Ações', sortable: false }
      ],
      nameSearch: '',
      editMode: false,
      editEmployeeId: null
    };
  },
  computed: {
    formValido() {
      if (this.editMode) return (
        this.form.name &&
        this.form.email &&
        this.form.idDocument &&
        this.form.role !== null &&
        this.form.companyId !== null
      );
      return (
        this.form.name &&
        this.form.email &&
        this.form.idDocument &&
        this.form.role !== null &&
        this.form.companyId !== null &&
        this.form.password.length >= 6 &&
        this.form.password === this.form.confirmPassword
      );
    },
    senhaCurta() {
      return this.form.password && this.form.password.length < 6;
    },
    senhasNaoBatem() {
      return (
        this.form.password &&
        this.form.confirmPassword &&
        this.form.password !== this.form.confirmPassword
      );
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isReadOnly() {
      return this.$store.getters.isReadOnly;
    },
    canManageEmployees() {
      return this.isSuperAdmin || this.isManager;
    },
    filteredItems() {
      const searchValue = this.nameSearch.toLowerCase();
      if (!searchValue) return this.items;
      return this.items.filter(employee => employee.name.toLowerCase().includes(searchValue))
    }
  },
  async mounted() {
    if (this.isSuperAdmin) await this.fetchCompanies();
    this.fetchEmployees();
  },
  methods: {
    filterVisibleRoles(employees) {
      const visibleRoles = [DB_ROLES.MANAGER, DB_ROLES.OPERATOR];
      return employees.filter(employee => visibleRoles.includes(employee.role));
    },
    getCompanyName(id) {
      const company = this.companies.find(c => c.value === id);
      return company?.text;
    },
    fetchRoles() {
      this.loading = true;
      request.get(
        DB_ROUTES.GET_ROLES,
        response => {
          const allowedRoles = response.data.filter(role => this.checkRolePermission(role));
          this.roles = allowedRoles.map(role => ({ value: role.id, text: role.name }));
          this.roles.unshift({
            value: null,
            text: 'Selecione um cargo'
          })
          this.loading = false;
        },
        error => {
          console.error('Erro ao buscar cargos:', error);
          this.error = 'Erro ao carregar cargos';
          this.loading = false;
        }
      );
    },
    fillEmployeeCompany() {
      if (this.companies.length > 0) {
        this.form.companyId = this.companies[0].value;
        return
      };
      this.loading = true;
      request.get(
        DB_ROUTES.GET_EMPLOYEE_BY_ID(this.$store.state.user.id),
        async (response) => {
          const company = await this.fetchCompanyInfo(response.data.companyId)
          this.companies = [{ value: company.id, text: company.name }];
          this.form.companyId = company.id;
          this.loading = false;
        },
        (error) => {
          console.error('Erro ao buscar dados de funcionário:', error);
          this.loading = false;
        }
      );
    },
    async fetchCompanyInfo(id) {
      try {
        const response = await api.get(DB_ROUTES.GET_COMPANY_BY_ID(id));
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar dados da empresa:', error);          
      } finally {
        this.loading = false;
      }
    },
    async fetchCompanies() {
      try {
        this.loading = true;
        const response = await api.get(DB_ROUTES.GET_ALL_COMPANIES);
        if (response.data) {
          this.companies = response.data.map((company) => ({
            value: company.id,
            text: company.name
          }));
          this.companies.unshift({
            value: null,
            text: 'Selecione uma empresa'
          })
        }
      } catch (error) {
        console.error('Erro ao buscar empresas:', error);
        this.error = 'Erro ao carregar empresas';
      } finally {
        this.loading = false;
      }
    },
    fetchEmployees() {
      // TODO: mocked content, remove later
      // this.items = this.sortEmployees([
      //   { id: 1, name: "SuperAdmin", company: "Brasil Agritest", role: "SuperAdmin" },
      //   { id: 2, name: "Gerente", company: "Brasil Agritest", role: "Gerente" },
      //   { id: 3, name: "Operador", company: "Brasil Agritest", role: "Operador" },
      //   { id: 4, name: "Empresa Mineira", company: "Empresa Mineira", role: "Gerente" },
      //   { id: 5, name: "Eduarda Martins", company: "SkyLabs", role: "Gerente" },
      //   { id: 6, name: "Maria Eduarda Campos Ribeiro", company: "ByteWave", role: "Operador" },
      //   { id: 7, name: "João Pedro Almeida da Silva", company: "InnovaTech", role: "Gerente" },
      //   { id: 8, name: "Ana Carolina Souza Fernandes Lopes", company: "SoftMind", role: "Operador" },
      //   { id: 9, name: "Isabela Correia", company: "CodeWave", role: "Gerente" },
      //   { id: 10, name: "João Oliveira", company: "NextVision", role: "Operador" },
      //   { id: 11, name: "Karen Ribeiro", company: "TechNova", role: "Gerente" },
      //   { id: 12, name: "Lucas Fernandes", company: "ByteWave", role: "Operador" },
      //   { id: 13, name: "Mariana Costa", company: "DataMind", role: "Gerente" },
      //   { id: 14, name: "Nathan Silva", company: "CodeWorks", role: "Operador" },
      //   { id: 15, name: "Otávio Teixeira", company: "SkyLabs", role: "Gerente" },
      //   { id: 16, name: "Luiz Henrique Pereira dos Santos", company: "InnovaTech", role: "Operador" },
      //   { id: 17, name: "Rafael Santos", company: "TechNova", role: "Gerente" },
      //   { id: 18, name: "Sofia Lima", company: "NextVision", role: "Operador" },
      //   { id: 19, name: "Thiago Mendes", company: "SoftMind", role: "Gerente" },
      //   { id: 20, name: "Ursula Figueiredo", company: "CodeWave", role: "Operador" },
      //   { id: 21, name: "Vitor Azevedo", company: "ByteWave", role: "Gerente" },
      //   { id: 22, name: "Wagner Pereira", company: "SkyLabs", role: "Operador" },
      //   { id: 23, name: "Ximena Duarte", company: "TechNova", role: "Gerente" },
      //   { id: 24, name: "Yago Moraes", company: "InnovaTech", role: "Operador" },
      //   { id: 25, name: "Zélia Tavares", company: "DataMind", role: "Gerente" },
      //   { id: 26, name: "Arthur Barros", company: "NextVision", role: "Operador" },
      //   { id: 27, name: "Beatriz Helena Costa Oliveira Lima", company: "SoftMind", role: "Gerente" },
      //   { id: 28, name: "Caio Rezende", company: "CodeWave", role: "Operador" },
      //   { id: 29, name: "Daniela Pinto", company: "ByteWave", role: "Gerente" },
      //   { id: 30, name: "Eduardo Ramos", company: "TechNova", role: "Operador" },
      //   { id: 31, name: "Alice Santos", company: "TechNova", role: "Gerente" },
      // ]);
      // this.loading = false;

      this.loading = true;
      if (this.isSuperAdmin) {
        request.get(
          DB_ROUTES.GET_ALL_EMPLOYEES,
          (response) => {
            const mappedEmployees = response.data.map((item) => ({
              id: item.id,
              name: item.name,
              company: this.getCompanyName(item.companyId) || 'Empresa não informada',
              role: item.userRole
            }));
            this.items = this.sortEmployees(this.filterVisibleRoles(mappedEmployees));
            this.loading = false;
          },
          (error) => {
            console.error('Erro ao buscar funcionários (super admin):', error);
            this.error = 'Erro ao carregar funcionários';
            this.loading = false;
          }
        );
      } else if (this.isManager) {
        const loggedInEmployeeId = this.$store.state.user.id;
        request.get(
          DB_ROUTES.GET_COMPANY_EMPLOYEES(loggedInEmployeeId),
          (response) => {
            const mappedEmployees = response.data.map((item) => ({
              id: item.id,
              name: item.name,
              company: item.companyId,
              role: item.userRole
            }));
            this.items = this.sortEmployees(this.filterVisibleRoles(mappedEmployees));
            this.loading = false;
          },
          (error) => {
            console.error('Erro ao buscar funcionários (gerente):', error);
            this.error = 'Erro ao carregar funcionários';
            this.loading = false;
          }
        );
      } else if (this.isReadOnly) {
        const loggedInEmployeeId = this.$store.state.user.id;
        request.get(
          DB_ROUTES.GET_COMPANY_EMPLOYEES(loggedInEmployeeId),
          (response) => {
            const mappedEmployees = response.data.map((item) => ({
              id: item.id,
              name: item.name,
              company: item.companyId,
              role: item.userRole
            }));
            this.items = this.sortEmployees(this.filterVisibleRoles(mappedEmployees));
            this.loading = false;
          },
          (error) => {
            console.error('Erro ao buscar funcionários (usuário comum):', error);
            this.error = 'Erro ao carregar funcionários';
            this.loading = false;
          }
        );
      } else {
        console.log('lógica de fetch não implementada para o cargo atual')
        this.items = []
        this.loading = false;
      }
    },
    sortEmployees(list) {
      return list.sort((a, b) => {
        // SuperAdmin role is always displayed first
        if (a.role === DB_ROLES.SUPER_ADMIN) return -1;
        if (b.role === DB_ROLES.SUPER_ADMIN) return 1;

        // then sort by company
        const companySort = a.company.toString().localeCompare(b.company)
        if (companySort !== 0) return companySort

        // then by role (manager first)
        if (a.role !== b.role) return a.role === DB_ROLES.MANAGER ? -1 : 1

        // lastly by name
        return a.name.localeCompare(b.name)
      })
    },
    formatarDocumento() {
      let doc = this.form.idDocument.replace(/\D/g, '');
      if (doc.length <= 11) {
        doc = doc.replace(/(\d{3})(\d)/, '$1.$2');
        doc = doc.replace(/(\d{3})(\d)/, '$1.$2');
        doc = doc.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      } else {
        doc = doc.replace(/^(\d{2})(\d)/, '$1.$2');
        doc = doc.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        doc = doc.replace(/\.(\d{3})(\d)/, '.$1/$2');
        doc = doc.replace(/(\d{4})(\d)/, '$1-$2');
      }
      this.form.idDocument = doc;
    },
    onSubmit() {
      if (!this.canManageEmployees || this.isReadOnly) {
        this.$bvToast.toast('Você não tem permissão para salvar alterações.', {
          title: 'Sem permissão',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }
      if (this.formValido) {
        if (this.editMode) this.editEmployee();
        else this.saveEmployee()
      }
    },
    editEmployee() {
      const payload = {
        id: this.editEmployeeId,
        name: this.form.name,
        email: this.form.email,
        // password: this.form.password, // TODO: backend does not allow to edit password yet
        document: this.form.idDocument,
        companyId: this.form.companyId,
        userRole: this.form.role
      };
      request.put(
        DB_ROUTES.PUT_EMPLOYEE(this.editEmployeeId),
        payload,
        response => {
          // this.updateEmployeesList(response.data); // TODO: update list (pending resolution of bug on PUT request)
          this.resetForm();
          this.editMode = false;
          this.editEmployeeId = null;
          this.$bvModal.hide('cadastroFuncionario-modal');
          this.$bvToast.toast('Dados do funcionário atualizados com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          });
        },
        error => {
          console.error('Erro ao atualizar funcionário:', error);
          
          // Extract the specific error message from the backend response
          let errorMessage = 'Erro ao atualizar funcionário.';
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }
          
          this.$bvToast.toast(errorMessage, {
            title: 'Erro',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          });
        }
      );
    },
    saveEmployee() {
      // Check if the role is "Gerente" (Manager) - role ID = 2
      const isManager = this.form.role === 2;
      
      const payload = {
        id: 0,
        name: this.form.name,
        email: this.form.email,
        password: this.form.password,
        document: this.form.idDocument,
        companyId: this.form.companyId
      };

      // Only include userRole if it's NOT a manager (createManager endpoint doesn't need it)
      if (!isManager) {
        payload.userRole = this.form.role;
      }

      // Use the correct endpoint based on the role
      const endpoint = isManager ? DB_ROUTES.POST_MANAGER : DB_ROUTES.POST_EMPLOYEE;

      request.post(
        endpoint,
        payload,
        response => {
          this.addNewEmployee(response.data);
          this.resetForm();
          this.$bvModal.hide('cadastroFuncionario-modal');
          this.$bvToast.toast('Funcionário cadastrado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          });
        },
        (error) => {
          console.error('Erro ao cadastrar funcionário:', error);
          
          // Extract the specific error message from the backend response
          let errorMessage = 'Erro ao cadastrar funcionário.';
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }
          
          this.$bvToast.toast(errorMessage, {
            title: 'Erro',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          });
        }
      );
    },
    addNewEmployee(employee) {
      const newEmployee = {
        id: employee.id,
        name: employee.name,
        company: this.isSuperAdmin ? this.getCompanyName(employee.companyId) : employee.companyId,
        role: employee.userRole
      }
      this.items = this.sortEmployees(this.filterVisibleRoles([...this.items, newEmployee]));
    },
    resetForm() {
      this.form.name = '';
      this.form.email = '';
      this.form.password = '';
      this.form.confirmPassword = '';
      this.form.idDocument = '';
      this.form.companyId = null;
      this.form.role = null;
    },
    showModal() {
      if (!this.canManageEmployees || this.isReadOnly) return;
      if (this.roles.length === 0) this.fetchRoles();
      if (this.isManager) this.fillEmployeeCompany();
      this.$bvModal.show('cadastroFuncionario-modal');
    },
    showFuncionariosModal(employeeId) {
      this.selectedEmployeeId = employeeId;
      this.$bvModal.show('funcionarios-modal');
    },
    goToEmployeeAnalyses(name) {
      this.$router.push({ path: '/analises', query: { employee: name } });
    },
    getRoleClass(role) {
      switch (role) {
        case DB_ROLES.MANAGER: return 'role-manager';
        case DB_ROLES.OPERATOR: return 'role-operator';
      }
    },
    getRoleId(roleName) {
      const roleFound = this.roles.find(role => role.text === roleName);
      return roleFound?.value;
    },
    checkRolePermission(role) {
      const managerPermissions = [DB_ROLES.MANAGER, DB_ROLES.OPERATOR];
      if (this.isManager) return managerPermissions.includes(role.name);
      if (this.isSuperAdmin) return true;
    },
    showEditModal(id) {
      if (!this.canManageEmployees || this.isReadOnly) return;
      this.editMode = true;
      this.editEmployeeId = id;
      if (this.roles.length === 0) this.fetchRoles();
      if (this.isManager) this.fillEmployeeCompany();
      // show the same modal, but with inputs prefilled
      this.$bvModal.show('cadastroFuncionario-modal');
      request.get(
        DB_ROUTES.GET_EMPLOYEE_BY_ID(id),
        response => {
          const employee = response.data;
          this.form = {
            name: employee.name,
            email: employee.email,
            idDocument: employee.document,
            companyId: employee.companyId,
            role: this.getRoleId(employee.userRole),
            password: '',  // TODO: backend does not allow to edit password yet
            confirmPassword: ''  // TODO: backend does not allow to edit password yet
          }
        },
        error => {
          console.error('Erro ao buscar dados de funcionário:', error);
        }
      );
    },
    handleNewEmployeeModalClose() {
      if (this.editMode) {
        this.editMode = false;
        this.editEmployeeId = null
        this.resetForm();
      } 
    },
    confirmDeleteEmployee(employeeId) {
      if (!this.canManageEmployees || this.isReadOnly) return;
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja remover este funcionário? Esta ação não pode ser desfeita.', {
        title: 'Confirmar Remoção',
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Sim, Remover',
        cancelTitle: 'Cancelar',
        footerClass: 'p-3',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            this.deleteEmployee(employeeId);
          }
        })
        .catch(err => {
          console.error('Erro ao exibir modal de confirmação:', err);
        });
    },
    deleteEmployee(id) {
      if (!this.canManageEmployees || this.isReadOnly) return;
      request.delete(
        DB_ROUTES.DELETE_EMPLOYEE(id),
        response => {
          // Remove employee from the list
          this.items = this.items.filter(item => item.id !== id);
          this.$bvToast.toast('Funcionário removido com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          });
        },
        error => {
          console.error('Erro ao remover funcionário:', error);
          const errorMessage = error.response?.data?.message || 'Erro ao remover funcionário.';
          this.$bvToast.toast(errorMessage, {
            title: 'Erro',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          });
        }
      );
    },
    // TODO: update list (pending resolution of bug on PUT request)
    // updateEmployeesList(updatedEmployee) {
    //   
    // }
  }
};
</script>

<style scoped>
.funcionarios-container {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-back {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  width: 45px;
  height: 45px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
}

.btn-back:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
}

.btn-back i {
  font-size: 1.2rem;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0;
}

.person-search {
  margin-bottom: 20px;
}

.search-label {
  margin: 0 8px 0 0;
  font-weight: 600;
  color: #495057;
}

.search-input {
  width: 300px;
  height: 38px;
  border: 2px solid #FF8C42;
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #FF7A29;
  box-shadow: 0 0 0 0.2rem rgba(255, 140, 66, 0.25);
}

.team-container {
  margin: 12px auto;
  padding: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.team-container:hover {
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
}

.team-list-wrapper {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  justify-items: center;
  align-items: flex-start;
  gap: 24px;
  padding: 0;
  margin: 0;
}

.person-card {
  width: 320px;
  padding: 24px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  transition: all 0.3s ease;
  border: 2px solid #f0f0f0;
}

.person-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(255, 140, 66, 0.15);
  border-color: #FF8C42;
}

.person-name {
  font-size: 1.25rem;
  font-weight: 700;
  width: 90%;
  margin-bottom: 12px;
  color: #2c3e50;
  line-height: 1.3;
}

.person-edit {
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 1.1rem;
  cursor: pointer;
  color: #6c757d;
  transition: color 0.2s ease;
}

.person-edit:hover {
  color: #FF8C42;
}

.person-info {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 4px;
}

.person-company {
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0;
  color: #495057;
}

.person-role {
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #000;
  color: #fff;
  width: fit-content;
  padding: 4px 8px;
  margin: 0;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.role-manager {
  background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
  color: #422800;
  box-shadow: 0 2px 4px rgba(255, 183, 0, 0.2);
}

.role-operator {
  background: linear-gradient(135deg, #FFB366 0%, #FF9944 100%);
  color: #422800;
  box-shadow: 0 2px 4px rgba(255, 153, 68, 0.2);
}

.person-actions {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.action-row {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

/* Orange Button Styles */
.btn-orange {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
}

.btn-orange:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
  color: white;
}

.btn-orange:active {
  transform: translateY(0);
}

.btn-orange:disabled {
  background: #cccccc;
  cursor: not-allowed;
  box-shadow: none;
}

/* Action Buttons */
.btn-orange-action {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-size: 0.875rem;
  white-space: nowrap;
  flex: 1;
  box-shadow: 0 2px 8px rgba(255, 140, 66, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-orange-action:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 140, 66, 0.35);
  color: white;
}

.btn-orange-action:active {
  transform: translateY(0);
}

.btn-orange-action i {
  margin: 0;
}

/* Delete Button */
.btn-delete-action {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-size: 0.875rem;
  white-space: nowrap;
  width: 100%;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-delete-action:hover {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.35);
  color: white;
}

.btn-delete-action:active {
  transform: translateY(0);
}

.btn-delete-action i {
  margin: 0;
}

.btn-small {
  padding: 10px 16px;
  font-size: 0.875rem;
}

/* Cancel Button */
.btn-cancel {
  background-color: white;
  border: 2px solid #FF8C42;
  color: #FF8C42;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background-color: #FFF5EF;
  border-color: #FF7A29;
  color: #FF7A29;
}

/* Header responsive */
.d-flex.justify-content-between.align-items-center.mb-4 {
  flex-wrap: wrap;
  gap: 12px;
}

/* Tablet */
@media (max-width: 991px) {
  .page-title {
    font-size: 1.75rem;
  }
  
  .team-container {
    padding: 20px;
  }
  
  .team-list-wrapper {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
  }
  
  .person-card {
    width: 100%;
    max-width: 350px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.5rem;
  }
  
  .team-container {
    padding: 16px;
    border-radius: 16px;
  }
  
  .team-list-wrapper {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .person-card {
    width: 100%;
    max-width: 100%;
    padding: 16px;
  }
  
  .person-name {
    font-size: 1.2rem;
  }
  
  .person-actions {
    gap: 10px;
  }
  
  .action-row {
    flex-direction: column;
    gap: 10px;
  }
  
  .action-row button {
    width: 100%;
  }
  
  .person-search {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .search-input {
    width: 100%;
  }
  
  /* Header responsive on mobile */
  .d-flex.justify-content-between.align-items-center.mb-4 {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }
  
  .d-flex.justify-content-between.align-items-center.mb-4 .btn-orange {
    width: 100%;
  }
}

/* Small mobile */
@media (max-width: 576px) {
  .btn-back {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 10px;
  }
  
  .btn-back i {
    font-size: 1rem;
  }
  
  .page-title {
    font-size: 1.25rem;
  }
  
  .team-container {
    padding: 12px;
    border-radius: 12px;
  }
  
  .person-card {
    padding: 12px;
  }
  
  .person-name {
    font-size: 1.1rem;
  }
  
  .person-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  
  .btn-small {
    padding: 6px 10px;
    font-size: 0.8rem;
    min-width: unset;
  }
  
  .btn-orange {
    padding: 8px 16px;
    font-size: 0.9rem;
    width: 100%;
  }
}

/* Modal form responsive */
@media (max-width: 768px) {
  .wrapper .row {
    margin-left: 0;
    margin-right: 0;
  }
  
  .wrapper .row > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 16px;
  }
}

</style>
